import React from 'react';

const Training = ({ training }) => {
    return <>Treninig</>
}

export default Training;